
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-translator",
      function () {
        return require("private-next-pages/video-translator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-translator"])
      });
    }
  